
import { Prop } from 'vue-property-decorator'
import { Vue } from 'vue-class-component'
import { setLocalStorage } from '@/helpers/cacheStorage'
import { KeyCache } from '@/model/key-cache.model'

export default class ModalBottomGoldOnboard extends Vue {
  @Prop() onClose!: () => void

  closeModal() {
    setLocalStorage(KeyCache.GOLD_ONBOARD, true)

    if (this.onClose) {
      setTimeout(() => {
        this.onClose()
      }, 300)
    }
  }
}
